import { render } from "./YouTubePlay.vue?vue&type=template&id=2f3cccd9"
import script from "./YouTubePlay.vue?vue&type=script&lang=js"
export * from "./YouTubePlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__